const isNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0;
const isNumber = (value) => typeof value === 'number' && Number.isFinite(value);

export function validateStaticChapters(chapters) {
  if (!Array.isArray(chapters)) {
    console.error('[StaticContent] chapters.json must export an array');
    return false;
  }

  for (const chapter of chapters) {
    if (!chapter || !isNonEmptyString(chapter.id)) {
      console.error('[StaticContent] each chapter must have a string `id`');
      return false;
    }
    if (!isNumber(chapter.chapter_number)) {
      console.error('[StaticContent] each chapter must have a numeric `chapter_number`');
      return false;
    }
    if (!Array.isArray(chapter.videos)) {
      console.error('[StaticContent] each chapter must have a `videos` array');
      return false;
    }
    for (const video of chapter.videos) {
      if (!video) {
        console.error('[StaticContent] each chapter video must be an object');
        return false;
      }
      // The UI only renders videos with a non-empty youtube_url, so this is the key field.
      if (!isNonEmptyString(video.youtube_url)) {
        console.error('[StaticContent] each chapter video must have a non-empty `youtube_url`');
        return false;
      }
      if (!video.hasOwnProperty('position') || !isNumber(video.position)) {
        console.error('[StaticContent] each chapter video must have numeric `position`');
        return false;
      }
      if (!video.hasOwnProperty('text') || typeof video.text !== 'string') {
        console.error('[StaticContent] each chapter video must have string `text` (can be empty)');
        return false;
      }
    }
  }

  return true;
}

export function validateStaticCodex(codexEntries) {
  if (!Array.isArray(codexEntries)) {
    console.error('[StaticContent] codex.json must export an array');
    return false;
  }

  for (const entry of codexEntries) {
    if (!entry || !isNumber(entry.id)) {
      console.error('[StaticContent] each codex entry must have numeric `id`');
      return false;
    }
    if (!isNonEmptyString(entry.title)) {
      console.error('[StaticContent] each codex entry must have non-empty `title`');
      return false;
    }
    if (!isNonEmptyString(entry.category)) {
      console.error('[StaticContent] each codex entry must have non-empty `category`');
      return false;
    }
    if (!entry.hasOwnProperty('description') || typeof entry.description !== 'string') {
      console.error('[StaticContent] each codex entry must have string `description`');
      return false;
    }
    if (!entry.hasOwnProperty('image') || typeof entry.image !== 'string') {
      console.error('[StaticContent] each codex entry must have string `image` (can be empty)');
      return false;
    }
  }

  return true;
}

export function validateStaticContent({ chapters, codexEntries }) {
  const okChapters = validateStaticChapters(chapters);
  const okCodex = validateStaticCodex(codexEntries);
  return okChapters && okCodex;
}

